<script lang="ts">
	import type { Snippet } from 'svelte';
	import type { ClassValue, HTMLAttributes } from 'svelte/elements';

	interface Props extends HTMLAttributes<HTMLTableElement> {
		header?: Snippet;
		body?: Snippet;
		tableClass?: ClassValue;
	}

	const { header, body, tableClass, ...restProps }: Props = $props();
</script>

<table {...restProps} class={['w-full text-center max-md:grid max-w-full', tableClass]}>
	{@render header?.()}
	<tbody>
		{@render body?.()}
	</tbody>
</table>

<style>
	table {
		border-spacing: 0;
		border-collapse: collapse;
		white-space: nowrap;
	}
</style>
